import {OrderMatrix} from "./OrderMatrix";
import axios from 'axios';
import { route } from 'ziggy-js';

export class MatrixProductFilters {
    init() {
        this.matrixFilters = document.querySelectorAll('.matrix-filters select');
        this.orderMatrixWrapper = document.querySelector('.ordermatrix-wrapper');
        this.orderMatrixSkeletonHtml = document.querySelector('.ordermatrix-skeleton').outerHTML;

        this.addEventListenersToMatrixFilters();

        // Sync option availability with the currently loaded matrix on first render.
        this.updateFilterOptions(this.getSelectedFilters(), { fetchWhenEmpty: true });
    }

    addEventListenersToMatrixFilters() {
        if (this.hasFilters()) {
            this.matrixFilters.forEach(filter => {
                filter.addEventListener('change', () => {
                    this.handleMatrixFilterChange();
                });
            });
        }
    }

    async handleMatrixFilterChange() {
        const orderMatrix = new OrderMatrix();

        this.orderMatrixWrapper.innerHTML = this.orderMatrixSkeletonHtml;

        // Update available options in sibling filters, then reload the matrix.
        await this.updateFilterOptions(this.getSelectedFilters());

        orderMatrix.load({
            query: {
                matrixProductFilters: this.getSelectedFilters()
            }
        });
    }

    getSelectedFilters() {
        const selectedFilters = [];

        this.matrixFilters.forEach(matrixFilter => {
            if (matrixFilter.value !== '') {
                selectedFilters.push({
                    filter_id: matrixFilter.dataset.filterId,
                    filter_value: matrixFilter.value
                });
            }
        });

        return selectedFilters;
    }

    /**
     * Fetch valid option values per filter from the backend and apply
     * disabled / hidden state to options that would yield no results.
     *
     * @param {Array<{filter_id: string, filter_value: string}>} selectedFilters
     */
    async updateFilterOptions(selectedFilters, { fetchWhenEmpty = false } = {}) {
        // Re-enable everything when nothing is selected.
        if (selectedFilters.length === 0) {
            this.matrixFilters.forEach(filter => {
                filter.querySelectorAll('option').forEach(option => {
                    option.disabled = false;
                    option.hidden = false;
                });
            });

            if (!fetchWhenEmpty) {
                return;
            }
        }

        const { modelno } = document.querySelector('.product').dataset;

        try {
            const response = await axios.get(
                route('catalog.matrix-filter-options', { modelNo: modelno }),
                {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    params: { matrixProductFilters: selectedFilters }
                }
            );

            const validValuesByFilterId = response.data;

            this.matrixFilters.forEach(filter => {
                const filterId = parseInt(filter.dataset.filterId);
                const validValues = validValuesByFilterId[filterId];

                if (!validValues) {
                    return;
                }

                filter.querySelectorAll('option').forEach(option => {
                    if (option.value === '') {
                        return; // always keep the placeholder
                    }

                    const isValid = validValues.includes(option.value);
                    option.disabled = !isValid;
                    option.hidden = !isValid;
                });

                // Reset the current selection if it is no longer valid.
                if (filter.value !== '' && !validValues.includes(filter.value)) {
                    filter.value = '';
                }
            });
        } catch (error) {
            console.error('Failed to fetch matrix filter options:', error);
        }
    }

    hasFilters() {
        return this.matrixFilters.length > 0;
    }
}
